import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { ColumnSelectComponent } from '../column-select/column-select.component';
import {FormControl} from '@angular/forms';
import { element } from '@angular/core/src/render3/instructions';

@Component({
  selector: 'app-reg-on-trip-report',
  templateUrl: './reg-on-trip-report.component.html',
  styleUrls: ['./reg-on-trip-report.component.css']
})
export class RegOnTripReportComponent implements OnInit {

  fieldValues = new FormControl();
  trip_list = [];

  private dp = [];
  displayedColumns = ['chx_select', 'sr', 'member_id', 'invoice_no', 'customer_name', 'mobile', 'national_id',
    'passport_no', 'passport_expiry_date', 'date_of_birth', 'age', 'gender', 'depend_count', 'final_total',
    'paid_amount', 'remain_amount', 'reference'];

  displayedColumns2 = ['sr', 'member_id', 'invoice_no', 'customer_name', 'mobile', 'national_id',
    'passport_no', 'passport_expiry_date', 'date_of_birth', 'age', 'gender', 'depend_count', 'final_total',
    'paid_amount', 'remain_amount', 'reference'];
  // , 'age'  'chx_select', 

  active_list = [{ 'status_id': 'ALL', 'status_name': 'الكل', 'status_name_en': 'All' },
    { 'status_id': '1', 'status_name': 'الرحلات النشطة', 'status_name_en': 'Ingoing Programs' },
    { 'status_id': '0', 'status_name': 'الرحلات المؤرشفة', 'status_name_en': 'Archived Programs' }];

  model = {
    'from_date': new Date(), 'to_date': undefined, 'active': '1', 'trip_id': '', 'only_heads': '0', 
    'has_comp': 'ALL', 'hajj_type': 'ALL', 'last_hajj_date': 'ALL', 'gender': 'ALL', 'reference': '', 
    'smoker': 'ALL', 'medical_care': 'ALL', 'title': 'تقرير المسجلين على برنامج'
  };

  hasCompList = [{ 'type_id': 'ALL', 'type_name': 'الكل', 'type_name_en': 'ALL' },
    { 'type_id': 'yes', 'type_name': 'تعم', 'type_name_en': 'Yes' },
    { 'type_id': 'no', 'type_name': 'لا', 'type_name_en': 'No' }];

  hajjTypeList = [{ 'type_id': 'ALL', 'type_name': 'الكل', 'type_name_en': 'ALL' },
    { 'type_id': 'duty', 'type_name': 'واجبة', 'type_name_en': 'Duty' },
    { 'type_id': 'desirable', 'type_name': 'مستحبة', 'type_name_en': 'Desirable' },
    { 'type_id': 'on_behalf_of', 'type_name': 'نيابة', 'type_name_en': 'On behalf of' }];

  hajjDateList = [{ 'type_id': 'ALL', 'type_name': 'الكل', 'type_name_en': 'ALL' },
    { 'type_id': 'more_than_five', 'type_name': 'أكثر من 5 سنوات', 'type_name_en': 'More than five years' },
    { 'type_id': 'less_than_five', 'type_name': 'أقل من 5 سنوات', 'type_name_en': 'Less than five years' }];

  smokeList = [{ 'type_id': 'ALL', 'type_name': 'الكل', 'type_name_en': 'ALL' },
    { 'type_id': 'true', 'type_name': 'مدخن', 'type_name_en': 'Smoker' },
    { 'type_id': 'false', 'type_name': 'غير مدخن', 'type_name_en': 'Not Smoker' }];

  medicalList = [{ 'type_id': 'ALL', 'type_name': 'الكل', 'type_name_en': 'ALL' },
    { 'type_id': 'true', 'type_name': 'يعاني من أمراض أو إعاقة مزمنة', 'type_name_en': 'Have disease or disability' },
    { 'type_id': 'false', 'type_name': 'لا يعاني من أمراض أو إعاقة مزمنة', 'type_name_en': 'Not have any disease or disability' }];

  genderList = [{ 'type_id': 'ALL', 'type_name': 'الكل', 'type_name_en': 'ALL' },
    { 'type_id': 'm', 'type_name': 'ذكر', 'type_name_en': 'Male' },
    { 'type_id': 'f', 'type_name': 'أنثى', 'type_name_en': 'Female' }];


  // today = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();
 
  // search_prog = {
  //   'placeholder': 'اسم البرنامج/ رقم البرنامج', 'class_name': 'longSearchField',
  //   'table_list': [{
  //     'table_name': '`trip`', 'selected_no': 'trip_id',
  //     'field_list': ['trip_name', 'trip_number'],
  //     'condition': " AND `trip`.`arrival_date` >= '" + this.today + "'"
  //   }]
  // };

  dialog_data = [{ 'id': 'sr', 'title_ar': 'الرقم', 'title_en': 'Number', 'checked': '1' },
    { 'id': 'member_id', 'title_ar': 'رقم العميل', 'title_en': 'Customer No.', 'checked': '1' },
    { 'id': 'invoice_no', 'title_ar': 'رقم العقد/ الفاتورة', 'title_en': 'Contract/ Invoice Number', 'checked': '1' },
    { 'id': 'customer_name', 'title_ar': 'اسم المسافر', 'title_en': 'Traveler Name', 'checked': '1' },
    { 'id': 'full_name', 'title_ar': 'الاسم الإنجليزي', 'title_en': 'English Name', 'checked': '0' },
    { 'id': 'customer_name_en', 'title_ar': 'الاسم الأول', 'title_en': 'First Name', 'checked': '0' },
    { 'id': 'customer_last_name', 'title_ar': 'العائلة', 'title_en': 'Last Name', 'checked': '0' },
    { 'id': 'member_head_relation', 'title_ar': 'صلة القرابة', 'title_en': 'Relation', 'checked': '0' },
    { 'id': 'mobile', 'title_ar': 'رقم الجوال', 'title_en': 'Mobile', 'checked': '1' },
    { 'id': 'national_id', 'title_ar': 'السجل المدني', 'title_en': 'Civil Registry', 'checked': '1' },
    { 'id': 'passport_no', 'title_ar': 'رقم الجواز', 'title_en': 'Passport No.', 'checked': '1' },
    { 'id': 'passport_expiry_date', 'title_ar': 'تاريخ الانتهاء الميلادي', 'title_en': 'Expiry Date (Gregorian)', 'checked': '1' },
    { 'id': 'expiry_date_hijri', 'title_ar': 'تاريخ الانتهاء الهجري', 'title_en': 'Expiry Date (Hijri)', 'checked': '0' },
    { 'id': 'date_of_birth', 'title_ar': 'تاريخ الميلاد الميلادي', 'title_en': 'Date of Birth (Gregorian)', 'checked': '1' },
    { 'id': 'dob_hijri', 'title_ar': 'تاريخ الميلاد الهجري', 'title_en': 'Date of Birth (Hijri)', 'checked': '0' },
    { 'id': 'age', 'title_ar': 'العمر', 'title_en': 'Age', 'checked': '1' },
    { 'id': 'gender', 'title_ar': 'الجنس', 'title_en': 'Gender', 'checked': '1' },
    { 'id': 'trip_depart_date', 'title_ar': 'تاريخ المغادرة', 'title_en': 'Depart Date', 'checked': '0' },
    { 'id': 'trip_arrival_date', 'title_ar': 'تاريخ العودة', 'title_en': 'Return Date', 'checked': '0' },
    { 'id': 'depend_count', 'title_ar': 'عدد التابعين', 'title_en': 'Dependent Count', 'checked': '1' },
    { 'id': 'final_total', 'title_ar': 'المجموع', 'title_en': 'Total', 'checked': '1' },
    { 'id': 'paid_amount', 'title_ar': 'المدفوع', 'title_en': 'Paid', 'checked': '1' },
    { 'id': 'remain_amount', 'title_ar': 'المتبقي', 'title_en': 'Remaining', 'checked': '1' },
    { 'id': 'tax', 'title_ar': 'الضريبة', 'title_en': 'Tax', 'checked': '0' },
    { 'id': 'reference', 'title_ar': 'المرجع', 'title_en': 'Reference', 'checked': '1' }, 
    { 'id': 'trip_name', 'title_ar': 'اسم البرنامج', 'title_en': 'Program Name', 'checked': '0' },
    { 'id': 'comment', 'title_ar': 'الملاحظات', 'title_en': 'Comments', 'checked': '0' },
    { 'id': 'companion', 'title_ar': 'مرافق', 'title_en': 'Companion', 'checked': '0' },
    { 'id': 'hajjType', 'title_ar': 'نوع الحجة', 'title_en': 'Hajj Type', 'checked': '0' },
    { 'id': 'lastHajjDate', 'title_ar': 'تاريخ آخر حجة', 'title_en': 'Last Hajj Date', 'checked': '0' },
    { 'id': 'smoking', 'title_ar': 'مدخن', 'title_en': 'Smoker', 'checked': '0' },
    { 'id': 'medicalCare', 'title_ar': 'عناية صحية', 'title_en': 'Medical Care', 'checked': '0' },
    { 'id': 'nationality', 'title_ar': 'الجنسية', 'title_en': 'Nationality', 'checked': '0' },
    { 'id': 'bank_name', 'title_ar': 'اسم البنك', 'title_en': 'Bank Name', 'checked': '0' },
    { 'id': 'holder_name', 'title_ar': 'اسم صاحب الحساب', 'title_en': 'Holder Name', 'checked': '0' },
    { 'id': 'bank_acct_number', 'title_ar': 'رقم الحساب (الآيبان)', 'title_en': 'Account Number (IBAN)', 'checked': '0' }];

    // { 'id': 'has_comp', 'title_ar': 'مرافق', 'title_en': 'Companion', 'checked': '0' },
    // { 'id': 'hajj_type', 'title_ar': 'نوع الحجة', 'title_en': 'Hajj Type', 'checked': '0' },
    // { 'id': 'last_hajj_date', 'title_ar': 'تاريخ آخر حجة', 'title_en': 'Last Hajj Date', 'checked': '0' },
    // { 'id': 'smoker', 'title_ar': 'مدخن', 'title_en': 'Smoker', 'checked': '0' },
    // { 'id': 'medical_care', 'title_ar': 'عناية صحية', 'title_en': 'Medical Care', 'checked': '0' }

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;
  colDialogRef: MatDialogRef<ColumnSelectComponent>;

  // id;
  total_registered = 0;
  total_final = 0;
  total_paid = 0;
  total_remain = 0;
  trip_info = {};
  trip_detail = '';
  Trip_Msg; View_Group_Head; No_Traveler_Msg;
  Search_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private route: ActivatedRoute, private router: Router,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  Reg_Report; Prog_Name; Prog_No; Total_Registered;
  Final_Total; Total_Paid; Total_Remain;
  Program_Placeholder;

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Reg_Report').subscribe((res: string) => {
      this.Reg_Report = res;
    });
    this.model['title'] = this.Reg_Report;

    translate.get('Prog_Name').subscribe((res: string) => {
      this.Prog_Name = res;
    });

    translate.get('Prog_No').subscribe((res: string) => {
      this.Prog_No = res;
    });

    translate.get('Total_Registered').subscribe((res: string) => {
      this.Total_Registered = res;
    });

    translate.get('Final_Total').subscribe((res: string) => {
      this.Final_Total = res;
    });

    translate.get('Total_Paid').subscribe((res: string) => {
      this.Total_Paid = res;
    });

    translate.get('Total_Remain').subscribe((res: string) => {
      this.Total_Remain = res;
    });

    translate.get('Program_Placeholder').subscribe((res: string) => {
      this.Program_Placeholder = res;
    });
    // this.search_prog.placeholder = this.Program_Placeholder;

    translate.get('Trip_Msg').subscribe((res: string) => {
      this.Trip_Msg = res;
    }); 

    translate.get('View_Group_Head').subscribe((res: string) => {
      this.View_Group_Head = res;
    }); 
    
    translate.get('No_Traveler_Msg').subscribe((res: string) => {
      this.No_Traveler_Msg = res;
    });  

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });
  }


  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['id'] != undefined) {

        let query = "SELECT `trip`.* FROM `trip` WHERE `trip`.`trip_id` = '" + params['id'] + "' AND `trip`.`status` = '1'";
        let obj = { cmd: 'getList', query: query };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            this.trip_list = data.data['list'];

            // this.trip_info = data.data['list']['0'];
            // this.trip_detail = this.trip_info['trip_name'] + '-' + this.trip_info['trip_number'];
            this.viewReport();
          });

        this.model['trip_id'] = params['id'].split(";");
        // this.getTripInfo();
      }
      // else 
      //   this.viewReport();
    });
  }

  // getTripInfo() {
    
  // }

  // changeStatus() {
  //   if (this.model['trip_status'] == 'active')
  //     this.search_prog['table_list']['0']['condition'] = " AND `trip`.`arrival_date` >= '" + this.today + "'";
  //   else
  //     this.search_prog['table_list']['0']['condition'] = " AND `trip`.`arrival_date` < '" + this.today + "'";
  // }

  // onChangeProg = function (search_result: object) {
  //   this.model['trip_id'] = (search_result['no'] != '' ? search_result['no'] : '0');
  //   if (this.model['trip_id'] != '0')
  //     this.getTripInfo(); 
  // }

  changeHead() {
    this.model['only_heads'] = ((document.getElementById('only_heads') as HTMLInputElement).checked ? '1' : '0');
  }

  search() {
    if (this.model['from_date'] == undefined && this.model['to_date'] == undefined && this.model['active'] == 'ALL') {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getTripList' };

    if (this.model['from_date'] != undefined) 
      obj['from_date'] = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate();

    if (this.model['to_date'] != undefined) 
      obj['to_date'] = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" + this.model['to_date'].getDate();

    if (this.model['active'] != 'ALL') 
      obj['active'] = this.model['active'];
  
    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.trip_list = data.data['list'];

        if (this.trip_list.length > 1) 
          this.trip_list.unshift({ 'trip_id': 'All', 
            'trip_name': (this.applicationConstants.user_lang == 'ar' ? "جميع البرامج" : "All Programs"), 
            'trip_number': "" });
      });

    // if (this.model['trip_id'] == '0') {
    //   alert(this.Trip_Msg);
    //   return;
    // }

    // this.total_registered = 0;
    // let obj = { cmd: 'getTripRegRep', 'trip_id': this.model['trip_id'] };

    // if (this.model['only_heads'] == '1') 
    //   obj['only_heads'] = this.model['only_heads'];

    // this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     console.log(data);

    //     this.dp = data.data['list'][0]['traveler_list'];
    //     this.dataSource = new MatTableDataSource(this.dp);
    //     this.dataSource.sort = this.sort;
    //     this.total_registered = data.data['list'][0]['total_registered'];

    //   });
  }

  viewReport() {
    if (this.model['trip_id'] == '') {
      alert(this.Trip_Msg);
      return;
    }

    let tripList = this.model.trip_id;
    let trip_id = '';

    let element = tripList[0];
    if (element == 'All') {
      this.trip_list.forEach(element1 => {
    
        if (trip_id != '')
          trip_id += ";";
  
        trip_id += element1.trip_id;
      });
    }
    else {
      for (let index = 0; index < tripList.length; index++) {
        let element = tripList[index];
  
        if (trip_id != '')
          trip_id += ";";
  
        trip_id += element;
      }
    }

    this.total_registered = 0;
    let obj = { cmd: 'getTripRegRep', 'trip_id': trip_id };

    if (this.applicationConstants.user_info['user_id'] == undefined)
      obj['agent_acct_number'] = this.applicationConstants.user_info['acct_number'];
    
    if (this.model['has_comp'] != 'ALL') 
      obj['has_comp'] = this.model['has_comp'];

    if (this.model['hajj_type'] != 'ALL') 
      obj['hajj_type'] = this.model['hajj_type'];

    if (this.model['last_hajj_date'] != 'ALL') 
      obj['last_hajj_date'] = this.model['last_hajj_date'];

    if (this.model['gender'] != 'ALL') 
      obj['gender'] = this.model['gender'];

    if (this.model['smoker'] != 'ALL') 
      obj['smoker'] = this.model['smoker'];

    if (this.model['medical_care'] != 'ALL') 
      obj['medical_care'] = this.model['medical_care'];

    if (this.model['reference'] != '') 
      obj['reference'] = this.model['reference']; 

    if (this.model['only_heads'] == '1') 
      obj['only_heads'] = this.model['only_heads'];

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp = data.data['list'][0]['traveler_list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
        this.total_registered = data.data['list'][0]['total_registered'];
        this.total_final = data.data['list'][0]['total_final'];
        this.total_paid = data.data['list'][0]['total_paid'];
        this.total_remain = data.data['list'][0]['total_remain'];
      });
  }

  column_select() {
    this.colDialogRef = this.dialog.open(ColumnSelectComponent, {
      hasBackdrop: false,
      data: this.dialog_data
    });
    this.colDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != undefined) {
          console.log(result);
          this.dialog_data = result;
          this.displayedColumns = ['chx_select'];
          this.displayedColumns2 = [];

          this.dialog_data.forEach(element => {
            if (element.checked == '1') {
              this.displayedColumns.push(element.id);
              this.displayedColumns2.push(element.id);
            }
          });
        }
      });

  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0">';
    let trip_list = this.model['trip_id'];
    let trip_str = '';

    this.trip_list.forEach(element1 => {
      for (let index = 0; index < trip_list.length; index++) {
        let element = trip_list[index];
  
        if (element == element1.trip_id) {
          if (trip_str != '')
            trip_str += " - ";
    
          trip_str += element1.trip_name + " (" + element1.trip_number + ")"; 
        }
      }
    });

    html_data += '<tr><td width="99%"> ' + this.Prog_Name + ': ' + trip_str + '</td></tr>';
    // html_data += '<tr><td width="33%"> ' + this.Prog_Name + ': ' + this.trip_info['trip_name'] + '</td><td width="33%"> ' +
    //   this.Prog_No + ': ' + this.trip_info['trip_number'] + '</td></tr>';
    
    html_data += '<tr><td width="50%"> ' + this.Total_Registered + ' ' + this.total_registered + '</td>';
    html_data += '<td width="50%"> ' + this.Final_Total + ' ' + this.total_final + '</td></tr>';

    html_data += '<tr><td width="50%"> ' + this.Total_Paid + ' ' + this.total_paid + '</td>';
    html_data += '<td width="50%"> ' + this.Total_Remain + ' ' + this.total_remain + '</td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('prog_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  printPassport() {
    let count = 0;
    let member_list = '';
    this.dp.forEach(element => {
      if ((document.getElementById('chx_select_' + element.member_id) as HTMLInputElement).checked) {
        count++;
        if (member_list != '')
          member_list += ';';
        member_list += element.member_id; 
      }
    });
    console.log(member_list);

    if (count == 0) 
      alert(this.No_Traveler_Msg);
    else {
      let form = (document.getElementById('form1') as HTMLFormElement);
      let html_data_field = document.forms[form.id]['html_data'] as HTMLInputElement;
      
      if (count == 1) 
        form.action = this.applicationConstants.generatePassport + "?member_id=" + member_list; 
      else if (count > 1) {
        html_data_field.value = String(member_list);
        form.action = this.applicationConstants.generatePassport + "?member_list"; 
      }
      form.submit();
    }
  }

  selectAll() {
    var selectAllInput = document.getElementById('chx_select_all') as HTMLInputElement;
    
    this.dp.forEach(element => {
      (document.getElementById('chx_select_' + element.member_id) as HTMLInputElement).checked = selectAllInput.checked;
    });
  }

}
